// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__x2667","text":"SelectPayment_text__1isxK","title":"SelectPayment_title__1wV-n","btn":"SelectPayment_btn__2KYzY"};